import wait from 'lib/promise/wait'

const LOYALTY_ACCOUNT_FETCH_POLL_MS = 50
const LOYALTY_ACCOUNT_FETCH_MAX_WAIT_MS = 5000

/**
 * Waits for an in-flight loyalty account read to settle, for up to 5 seconds. Returns straight
 * away when no read is in flight.
 */
async function waitForLoyaltyAccountFetch(getState: () => App.State): Promise<void> {
  const deadline = Date.now() + LOYALTY_ACCOUNT_FETCH_MAX_WAIT_MS
  while (getState().loyalty.account.fetching && Date.now() < deadline) {
    await wait(LOYALTY_ACCOUNT_FETCH_POLL_MS)
  }
}

export default waitForLoyaltyAccountFetch
